import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import {MenuModulesEnum} from './@shared/enums/menu_modules.enum';
import * as _ from 'lodash';
import {CommonService} from './@shared/services/common.service';
import {CacheService} from './@shared/services/cache.service';
import {UserMgmtService} from './@shared/new-services/user-mgmt.service';
import {NotificationService} from './@shared/new-services/notification.service';
import {LoginDetailsService} from './login/login-details.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul class="layout-menu">
            <div class="card company-selection-bg p-mx-2 p-mt-4 p-mb-0" style="margin-bottom: 0 !important;">
                <!--                <h5>Selected Companies</h5>-->
                <div class=""
                     style="min-height: 9vh; max-height: 9vh; overflow-x: hidden;">
                    <div class="p-py-2 p-text-center p-ai-center"
                         *ngIf="cacheService.retrieveParsedResponse('selected-companies')?.length === 0 || !cacheService.retrieveParsedResponse('selected-companies')">
                        {{'No Company Selected !'}}
                        {{'Showing For All !'}}
                    </div>
                    <div class="p-py-1"
                         *ngFor="let company of cacheService.retrieveParsedResponse('selected-companies-name');">
                        <ul>
                            <li>
                                {{company}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"
                style="margin-top: -13px"></li>
        </ul>
    `,
    styleUrls: ['./app.topbar.component.scss']
})
export class AppMenuComponent implements OnInit {

    model: any[];
    loggedInUser: any;

    constructor(private commonService: CommonService, public app: AppComponent, public cacheService: CacheService,
                private userMgmtService: UserMgmtService, private notificationService: NotificationService,
                private loginDetailsService: LoginDetailsService) {
        this.getCurrentUser();
    }

    ngOnInit() {
        this.model = [
            {
                items: []
            }
        ];
    }


    getCountOfUnreadNotifications() {
        this.notificationService.getNotificationUnreadCount()
            .subscribe((res) => {
                this.model.map((x) => {
                    x?.items?.map((y) => {
                        if (y.label === 'Notifications') {
                            res = res > 500 ? '500+' : res;
                            y.label = res ? 'Notifications (' + res + ')' : y.label;
                        }
                    });
                });
            }, error => {
                console.log(error);
            });
    }

    getCurrentUser() {
        this.userMgmtService
            .getCurrentUser()
            .subscribe((x) => {
                this.cacheService.cacheResponse('detailedLoggedInUser', x);
                this.loginDetailsService.setLoggedInUser(x);
                this.loggedInUser = x;
                const sortedMenu = _.sortBy(x?.moduleAccess, 'sequenceNumber');
                x.moduleAccess = sortedMenu;

                x.moduleAccess?.map((menuAccess) => {
                    // Booking Summary Hide/Show
                    if (menuAccess.moduleCode === MenuModulesEnum.bookingSummary) {
                        this.model.map((menu) => {
                            if (menuAccess.visible) {
                                menu.items.push(
                                    {
                                        label: 'Booking Summary',
                                        routerLink: ['/booking-summary'],
                                        notSelectedIcon: 'assets/branding/menu-icons-not-selected/booking-summary.svg',
                                        selectedIcon: 'assets/branding/menu-icons-selected/booking-summary.svg'
                                    }
                                );
                            }
                        });
                    }

                    // Schedule Hide/Show
                    if (menuAccess.moduleCode === MenuModulesEnum.schedule) {
                        this.model.map((menu) => {
                            if (menuAccess.visible) {
                                menu.items.push(
                                    {
                                        label: 'Schedule',
                                        icon: 'pi pi-fw pi-calendar-plus',
                                        notSelectedIcon: 'assets/branding/menu-icons-not-selected/schedule.svg',
                                    },
                                );
                            }
                        });
                    }

                    // Shipment Tracking Hide/Show
                    if (menuAccess.moduleCode === MenuModulesEnum.shipmentTracking) {

                        this.model.map((menu) => {
                            if (menuAccess.visible) {
                                menu.items.push(
                                    {
                                        label: 'Shipment Tracking',
                                        routerLink: ['/tracking-vertical'],
                                        notSelectedIcon: 'assets/branding/menu-icons-not-selected/shipment-tracking.svg',
                                        selectedIcon: 'assets/branding/menu-icons-selected/shipment-tracking.svg'

                                    },
                                );
                            }
                        });
                    }

                    // Invoice & Document Hide/Show
                    if (menuAccess.moduleCode === MenuModulesEnum.invoiceAndDocuments) {
                        this.model.map((menu) => {
                            if (menuAccess.visible) {
                                menu.items.push(
                                    {
                                        label: 'Invoices & Documents',
                                        routerLink: ['/invoices'],
                                        notSelectedIcon: 'assets/branding/menu-icons-not-selected/invoice-and-docs.svg',
                                        selectedIcon: 'assets/branding/menu-icons-selected/invoice-and-docs.svg'
                                    },
                                );
                            }
                        });
                    }

                    // SOA Hide/Show
                    if (menuAccess.moduleCode === MenuModulesEnum.soa) {
                        this.model.map((menu) => {
                            if (menuAccess.visible) {
                                menu.items.push(
                                    {
                                        label: 'Statement of Accounts',
                                        routerLink: ['/account-statements'],
                                        notSelectedIcon: 'assets/branding/menu-icons-not-selected/soa.svg',
                                        selectedIcon: 'assets/branding/menu-icons-selected/soa.svg',
                                    },
                                );
                            }
                        });
                    }

                    // Admin Hide/Show
                    if (menuAccess.moduleCode === MenuModulesEnum.admin) {
                        this.model.map((menu) => {
                            if (menuAccess.visible) {
                                menu.items.push(
                                    {
                                        label: 'Admin',
                                        icon: 'pi pi-fw pi-user',
                                        notSelectedIcon: 'assets/branding/menu-icons-not-selected/admin.svg',
                                        selectedIcon: 'assets/branding/menu-icons-not-selected/admin.svg',
                                        items: [
                                            {
                                                label: 'Manage Users',
                                                routerLink: ['/user-management'],
                                                selectedIcon: '',
                                                notSelectedIcon: '',
                                                target: '_blank'
                                            },
                                        ]
                                    },
                                );
                            }
                        });
                    }

                    // Notification Hide/Show
                    if (menuAccess.moduleCode === MenuModulesEnum.notifications) {
                        this.model.map((menu) => {
                            if (menuAccess.visible) {
                                menu.items.push(
                                    {
                                        label: 'Notifications',
                                        routerLink: ['/notifications'],
                                        notSelectedIcon: 'assets/branding/menu-icons-not-selected/notifications.svg',
                                        selectedIcon: 'assets/branding/menu-icons-selected/notifications.svg'
                                    }
                                );
                            }
                        });
                    }

                });


                // Manage Roles Hide/Show
                if (x?.viewRoles) {
                    this.model.map((menu) => {
                        menu?.items.map((menuOption) => {
                            if (menuOption?.label === 'Admin') {
                                menuOption.items.push({
                                    label: 'Manage Roles',
                                    selectedIcon: '',
                                    notSelectedIcon: '',
                                    target: '_blank',
                                    routerLink: ['/roles-management']
                                });
                            }
                        });
                    });

                }

                // Customer Onboard & Application Analytics Hide/Show
                if (x?.viewOnBoarding) {
                    this.model.map((menu) => {
                        menu?.items.map((menuOption) => {
                            if (menuOption?.label === 'Admin') {
                                menuOption.items.push(
                                    {
                                        label: 'Customer Onboard',
                                        routerLink: ['/customer-onboard'],
                                        selectedIcon: '',
                                        notSelectedIcon: '',
                                    },
                                    {
                                        label: 'Web Analytics',
                                        routerLink: ['/web-analytics'],
                                        selectedIcon: '',
                                        notSelectedIcon: '',
                                    },
                                );
                            }
                        });
                    });
                }

                // Portal Demo Videos
                this.model.map((res) => {
                    res?.items?.push(
                        {
                            label: 'Training Videos',
                            routerLink: ['/fr-training-videos'],
                            icon: 'pi pi-fw pi-video',
                            notSelectedIcon: '',
                            selectedIcon: '',
                        },
                    );
                });
                this.getCountOfUnreadNotifications();
            });
    }
}
